var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "introVideosWrapper introVideosModal"
  }, [_c('new-modal-wrapper', {
    attrs: {
      "widthModal": "100%",
      "modal-name": "introVideos",
      "fullHeight": true,
      "heightModal": _vm.fullScreen || _vm.isMobile ? '100%' : 'auto',
      "content-component": "introVideos",
      "cta-primary-button": "ugcIntroVideosModalButton",
      "max-width-modal": _vm.fullScreen ? Infinity : 500,
      "headerTitle": _vm.title,
      "showCloseIcon": _vm.type === 'customizer'
    },
    on: {
      "cta-action": function ctaAction($event) {
        return _vm.onNext();
      },
      "before-close": function beforeClose($event) {
        return _vm.onCloseModal();
      }
    }
  }, [_vm.steps || _vm.steps.length > 0 ? _c('intro-videos', {
    attrs: {
      "onSlideChange": _vm.onSlideChange,
      "onNext": _vm.onNext,
      "steps": _vm.steps,
      "assetsPath": _vm.assets
    }
  }) : _vm._e()], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }